import Swal from "sweetalert2";
import {loading} from "./loading";

/**
 * A small shortcut to call a Swal modal indicating success
 *
 * @param {*} message The message to show
 * @param {*} timer  The time in milliseconds the modal should last
 *
 * @returns A Swal promise invocation
 */
function swalSuccess(message, timer = 3500) {
	return Swal.fire({
		icon: 'success',
		text: message,
		timer: timer
	})
}

/**
 * @param {SweetAlertOptions|{}}options
 * @return {Promise<SweetAlertResult<Awaited<any>>>}
 */
function swalConfirm(options = {}) {
	options = {
		title: 'Are you sure?',
		text: '',
		icon: 'warning',
		showCancelButton: true,
		confirmButtonColor: '#3085d6',
		cancelButtonColor: '#d33',
		confirmButtonText: 'Yes',
		cancelButtonText: 'Cancel',
		...options
	}

	return Swal.fire(options)
}

function handleAjaxSuccess(response, callback = (response) => {
	loading();
	// noinspection JSUnresolvedVariable
	if (response.data.redirectUrl) {
		// noinspection JSUnresolvedVariable
		window.location.href = response.data.redirectUrl;
	} else {
		window.location.reload();
	}
}) {
	swalSuccess(response.data.message)
		.then(() => {
			callback(response);
		});
}

export {
	swalSuccess,
	swalConfirm,
	handleAjaxSuccess
}
